import { render } from "./JokeCard.vue?vue&type=template&id=5d8a55d6&scoped=true"
import script from "./JokeCard.vue?vue&type=script&lang=js"
export * from "./JokeCard.vue?vue&type=script&lang=js"

import "./JokeCard.vue?vue&type=style&index=0&id=5d8a55d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8a55d6"]])

export default __exports__